import { MultiLangString } from './lingua_sistema';
import { HmModelRest } from './abstract_model';

export class Cittadinanza extends HmModelRest {
    static readonly rest_path = 'cittadinanze';

    id: number;
    nome: MultiLangString;
    codice_istat: number;
    comunita_europea: boolean;
    alta_immigrazione: boolean;
    psa: boolean;
    //label: string;
}

export class TitoloStudio extends HmModelRest {
    static readonly rest_path = 'titoli_studio';
    id: number;
    nome: MultiLangString;
    descrizione: MultiLangString;
    bassaistruzione: boolean;
}

export class Professione extends HmModelRest {
    static readonly rest_path = 'professioni';
    id: number;
    nome: MultiLangString;
    rischio: boolean;
    label: string;
}

